import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthenticationFacade } from '../../../store/authentication/authentication.facade';
import { CustomizationFacade } from '../../../store/customization/customization.facade';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
    isPasswordReset: boolean = false;
    customizations$ = this.customizationFacade.customization$;

    constructor(
        private router: Router,
        private authenticationFacade: AuthenticationFacade,
        private customizationFacade: CustomizationFacade
    ) {}

    passwordResetForm: FormGroup = new FormGroup({
        email: new FormControl('')
    });

    ngOnInit() {
        this.passwordResetForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email])
        });
    }

    get email() {
        return this.passwordResetForm.get('email');
    }

    submitPasswordReset(): void {
        if (this.passwordResetForm.valid) {
            this.authenticationFacade.resetPassword(this.email?.value);
            this.isPasswordReset = true;
        }
    }

    goToLoginPage(): void {
        void this.router.navigate(['/auth/sign-in']).then(() => {});
    }
}
